import { useState } from 'react';
import { NAV_PAGES, SERVICES_DATA } from '../data';
import './Footer.css';

export default function Footer({ setPage }) {
  const [email, setEmail] = useState('');

  const go = (p) => {
    if (setPage) {
      setPage(p);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setEmail('');
  };

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-grid">
          {/* Brand */}
          <div>
            <div className="footer-brand">
              FITNESS <span>KING</span>
            </div>

            <p className="footer-tagline">
              Forging strong bodies, confident minds, and disciplined lifestyles.
              Train hard, stay focused, and grow with Fitness King.
            </p>

            <div className="footer-socials">
              {[
                ['f', 'Facebook', 'https://www.facebook.com/people/Fitness-King-BBSR/61578453398651/'],
                ['📷', 'Instagram', 'https://www.instagram.com/fitnesskingbbsr/'],
                ['▶', 'YouTube', 'https://www.youtube.com/channel/UCFj3D1kwadwDTP6d1l73GwA'],
              ].map(([ic, label, link]) => (
                <a
                  key={label}
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fsocial"
                  aria-label={label}
                  title={label}
                >
                  {ic}
                </a>
              ))}
            </div>
            
            {/* Newsletter */}
            <form className="newsletter-bar" onSubmit={handleSubscribe}>
              <div className="nl-title">STAY SHARP</div>
              <div className="nl-sub">
                Weekly training tips, class schedules, and member offers.
              </div>

              <div className="nl-row">
                <input
                  className="nl-input"
                  type="email"
                  placeholder="your@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  aria-label="Email address"
                />
                <button className="nl-btn" type="submit">
                  Subscribe
                </button>
              </div>
            </form>
          </div>

          {/* Navigate */}
          <div>
            <div className="footer-col-title">Navigate</div>
            <ul className="footer-links">
              {NAV_PAGES.map((p) => (
                <li key={p}>
                  <button type="button" className="footer-link-btn" onClick={() => go(p)}>
                    → {p}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <div className="footer-col-title">Services</div>
            <ul className="footer-links">
              {SERVICES_DATA.map((s) => (
                <li key={s.title}>
                  <button
                    type="button"
                    className="footer-link-btn"
                    onClick={() => go('Services')}
                  >
                    → {s.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <div className="footer-col-title">Contact</div>
            <ul className="footer-links contact-list">
              <li>
                <span>📍 New Road, Jagamara, Bhubaneswar, Odisha 751020</span>
              </li>
              <li>
                <a href="tel:+919938326846">📞 +91 9938326846</a>
              </li>
              <li>
                <a href="mailto:fitnesskingbbsr@gmail.com">✉️ fitnesskingbbsr@gmail.com</a>
              </li>
              <li className="contact-gap">
                <span>Morning : 6am – 12pm</span>
              </li>
              <li>
                <span>Evening: 4:30pm – 9:30pm</span>
              </li>
              <li>
                <span>Sunday: Off</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copy">
            © 2025 <span>FITNESS KING</span>. All rights reserved.
          </div>

          <div className="footer-legal">
            <button type="button" className="footer-link-btn">Privacy Policy</button>
            <button type="button" className="footer-link-btn">Terms of Service</button>
            <button type="button" className="footer-link-btn">Cookie Policy</button>
          </div>
        </div>
      </div>
    </footer>
  );
}